import { Box } from '@mui/material';
import React, { Suspense } from 'react';

import Header from '../../components/Header';

const LazyPieChart = React.lazy(() => import('../../components/PieChart'));

const Pie = () => {
  return (
    <Box m="20px">
      <Header title="Pie Chart" subtitle="Simple Pie Chart" />
      <Box height="75vh">
        <Suspense fallback={<div>Loading...</div>}>
          <LazyPieChart />
        </Suspense>
      </Box>
    </Box>
  );
};

export default Pie;
